// Centralized configuration
export const BACKEND_URL =
	process.env.NODE_ENV === 'production' ? 'https://backend.b-reporter.com' : 'http://localhost:8083';

// Base used to build shareable post links (/share/<id>/<hash>). Points at the
// website itself. Override with REACT_APP_SHARE_BASE_URL; otherwise it follows
// the build mode (localhost in dev, b-reporter.com in prod). Trailing slash is
// trimmed so callers can append `/share/...`.
export const WEB_BASE_URL = (
	process.env.REACT_APP_SHARE_BASE_URL ||
	(process.env.NODE_ENV === 'production' ? 'https://b-reporter.com' : 'http://localhost:3000')
).replace(/\/$/, '');
export const RISKOMETER_API_URL = 'https://backend.b-reporter.com/riskometer/analyze/';

// Media + profile-pic base URLs. Split out from BACKEND_URL so media can be
// moved to a CDN / blob later by setting REACT_APP_MEDIA_BASE_URL /
// REACT_APP_PROFILEPIC_BASE_URL at build time — no code change. The DB stores
// bare filenames, so only this base changes. Defaults preserve today's behavior.
// Trailing slashes are trimmed; use the mediaUrl()/profilePicUrl() helpers so
// every call site switches to the CDN at once.
export const MEDIA_BASE_URL = (
	process.env.REACT_APP_MEDIA_BASE_URL || `${BACKEND_URL}/api/media`
).replace(/\/$/, '');
export const PROFILEPIC_BASE_URL = (
	process.env.REACT_APP_PROFILEPIC_BASE_URL || `${BACKEND_URL}/profilepic`
).replace(/\/$/, '');

export const mediaUrl = (name: string) => `${MEDIA_BASE_URL}/${name}`;
export const profilePicUrl = (name: string) => `${PROFILEPIC_BASE_URL}/${name}`;
